































































































import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import CStepper from '~/components/shared/configurable/stepper/CStepper.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import { useStatic } from '~/compositions/useStatic'
import { useI18n } from '~/compositions/i18n'
import { useDep } from '~/compositions/dependency-container'
import RouteGuardService from '~/services/RouteGuardService'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import AdvertisingStep from '~/components/shared/advertising/AdvertisingStep.vue'
import CContentSlider from '~/components/shared/configurable/CContentSlider.vue'

export default defineComponent({
  components: { CContentSlider, AdvertisingStep, CStepper },
  props: {
    inDashboard: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup() {
    const s = useStatic()
    const { t, locale } = useI18n()
    const routeGuardService = useDep(RouteGuardService)
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const isSingleOrAnon = computed(() => userGetters('isSingleOrAnon'))

    const activeStepIndex = ref(0)

    const handleChangeStep = (evt: number) => {
      activeStepIndex.value = evt
    }

    const hasAccess = computed(() => {
      return routeGuardService.userCanUseInHouseAds() || isSingleOrAnon.value
    })

    function getStepImg(stepNumber: number) {
      return locale === 'el'
        ? s(`/nuxt-static/img/inhouse-ads/step-${stepNumber}-min.png`)
        : s(`/nuxt-static/img/inhouse-ads/step-${stepNumber}-min-eng.png`)
    }

    const steps = ref([
      {
        imgUrl: getStepImg(1),
        step: t('step_number', { number: 1 }),
        text: t('choose_campaign_name')
      },
      {
        imgUrl: getStepImg(2),
        step: t('step_number', { number: 2 }),
        text: t('choose_the_name')
      },
      {
        imgUrl: getStepImg(3),
        step: t('step_number', { number: 3 }),
        text: t('set_the_amount')
      },
      {
        imgUrl: getStepImg(4),
        step: t('step_number', { number: 4 }),
        text: t('choose_the_distribution')
      },
      {
        imgUrl: getStepImg(5),
        step: t('step_number', { number: 5 }),
        text: t('select_ad_banner_name')
      },
      {
        imgUrl: getStepImg(6),
        step: t('step_number', { number: 6 }),
        text: t('set_banners_from_the_templates')
      },
      {
        imgUrl: getStepImg(7),
        step: t('step_number', { number: 7 }),
        text: t('target_the_audience')
      }
    ])
    return {
      steps,
      handleChangeStep,
      hasAccess,
      activeStepIndex
    }
  },
  i18n: defineComponentTranslations({
    steps_to_advertise: {
      en: 'What are the steps to advertise on Car.gr?',
      el: 'Ποια είναι τα βήματα για να Διαφημιστείς στο Car.gr;'
    },
    steps_to_advertise_start: {
      en: 'What are the steps to ',
      el: 'Ποια είναι τα βήματα για να '
    },
    steps_to_advertise_underline: {
      en: 'Αdvertise',
      el: 'Διαφημιστείς'
    },
    steps_to_advertise_end: {
      en: ' on Car.gr?',
      el: ' στο Car.gr;'
    },
    start_campaign: {
      en: 'Start a campaign',
      el: 'Δημιουργία καμπάνιας'
    },
    step_number: {
      en: 'Step {number}',
      el: 'Βήμα {number}'
    },
    choose_campaign_name: {
      en: 'Choose your campaign name.',
      el: 'Διάλεξε το όνομα της καμπάνιας σου.'
    },
    choose_the_name: {
      en: 'Choose the name and set the time period of your ad.',
      el: 'Επίλεξε το όνομα και όρισε το χρονικό διάστημα της διαφήμισής σου.'
    },
    set_the_amount: {
      en: 'Set the amount you want to spend.',
      el: 'Όρισε το ποσό που θέλεις να ξοδέψεις.'
    },
    choose_the_distribution: {
      en: 'Choose the distribution method for your ad impressions.',
      el: 'Επίλεξε τον τρόπο διανομής για τις εμφανίσεις της διαφήμισής σου.'
    },
    select_ad_banner_name: {
      en: 'Select the name of the ad banner and its landing page.',
      el: 'Επίλεξε το όνομα του banner και την σελίδα προορισμού του.'
    },
    set_banners_from_the_templates: {
      en: 'Set banners from the templates or upload custom ones.',
      el: 'Όρισε banners από τα προσχέδια ή ανέβασε δικά σου.'
    },
    target_the_audience: {
      en: 'Target the audience you want your exposure to.',
      el: 'Στόχευσε το κοινό που επιθυμείς τη προβολή σου.'
    }
  })
})
